import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Dialog, DialogTitle, DialogContent, IconButton, CircularProgress, Typography, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SalvageIcon from "../../assets/images/salvage-logo-color.png";
import KeyStoneIcon from "../../assets/images/header-logo-color-tab.png";
import "./RegisterModal.scss";

type StatusProps = {
  applicationID: string;
  status: string;
  statusId: string;
};


type TopBarRegisterProps = {
  status :  StatusProps[];
  navigateValue : string;
};


const RegisterModal: React.FC<TopBarRegisterProps> = ({
  status,
  navigateValue,
}) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(
    false
  );

  const [salvageDescription, setSalvageDescription] = useState("You have attempted to navigate to our new Salvage site but we show that you currently don't have an active Salvage account. Please click the link below if you would like to request access!");
  const [salvagePrepioletText, setSalvagePrepioletText] = useState("This feature is part of our next big change coming soon to the LKQ Portal! In the next few months you will be able to shop for used auto parts via our new Salvage site along with a few quality of life improvements for managing all of your activity across the different sites housed under the LKQ Portal. All the new functionality will be seamlessly integrated into the LKQ Portal landing page and will be accessible using a one-time login once the new update is live. Until then familiarize yourself with what you can look forward to in the future!");
  const [afterMarketDescription, setAfterMarketDescription] = useState("You have attempted to navigate to our OrderKeystone Aftermarket site but we show that you currently don't have an active Aftermarket account. Please click the link below if you would like to request access!");
  const [hasSalvagePreview, setHasSalvagePreview] = useState(true);
  const [isC2CUser, setIsC2CUser] = useState(false);
  const handleRegister = () => {
    const redirectUrl = `${process.env.REACT_APP_LKQPORTAL_URL}add-business-to-user` || "/";
    window.location.replace(redirectUrl);
  }
  const salvageText = (isStatus : string) => {
      switch (isStatus) {
        case 'Pending':
          return "You have already submitted a request to have LKQ Salvage access added to your account. Please allow for 2-3 business for your request to be processed and reviewed. You will receive an email confirming this once the process is complete.";
        case 'Denied':
          return "Sorry, but your request has been denied. Please call your customer service representative for further assistance.";
        case 'Disabled':
          return "Sorry but your account has been disabled.  Please contact your customer service representative for further assistance.";
        case 'Hold':
          return "Sorry but your request has been placed on hold.  Please contact your customer service representative for further assistance.";
        default:
          return "";
      }
  }

  const AfterMarketText = (isStatus : string) => {
      switch (isStatus) {
        case 'Pending':
          return "You have already submitted a request to have LKQ Salvage access added to your account. Please allow for 2-3 business for your request to be processed and reviewed. You will receive an email confirming this once the process is complete.";
        case 'Denied':
          return "Sorry, but your request has been denied. Please call your customer service representative for further assistance.";
        case 'Disabled':
          return "Sorry but your account has been disabled.  Please contact your customer service representative for further assistance.";
        case 'Hold':
          return "Sorry but your request has been placed on hold.  Please contact your customer service representative for further assistance.";
        default:
          return "";
      }
  }

  useEffect(() => {
    if (navigateValue != "" && navigateValue != null) {
      setOpen(true);
    }
  }, [status, navigateValue]);

  const handleClose = () => setOpen(false);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth className="informationPopup">
      <DialogTitle>
        {navigateValue == "Salvage" ? "Register with LKQ Salvage!" : "Register with LKQ Aftermarket!" }

        {/* Close Button */}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Typography><img src={navigateValue  == "Salvage"  ? SalvageIcon : KeyStoneIcon}></img></Typography>
        {
          status.length > 0 ? <Typography>
            {navigateValue == "Salvage" ? 
            salvageText(status?.[0].status) : AfterMarketText(status?.[0].status) }
            </Typography> : null
        }
        
        {((status == null || status.length == 0)) ? 
          <>
          {navigateValue  == "Salvage"  ? <>
          {isC2CUser == false ? <Typography>{salvageDescription}</Typography> : null}
          {hasSalvagePreview == false ? <Typography>{salvagePrepioletText}</Typography> : null}
          </> : <Typography>{afterMarketDescription}</Typography>}
          <div className="button-wrapper"><Button onClick={handleRegister}>{navigateValue == "Salvage" ? "Request a Salvage account" :  "Request an Aftermarket account" }</Button></div>
          </>
         : null
      }
         </DialogContent>
    </Dialog>
  );
};

export default RegisterModal;
